import { makeStyles } from '@branchjs/neo-components';
import { cx } from '@emotion/css';
import React, { type ReactNode } from 'react';
import { ImageService } from '../../main/services/ImageService/ImageService';

const BRANCH_LOGO_FILE_LOCATION = '/static/images/branch-logos/branch-logo_dark.svg';

export const useStyles = makeStyles(() => ({
  branchLogo: {
    width: '100px',
    height: '36px',
    position: 'absolute',
    left: '36px',
    top: '36px',
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
  },
}));

const FullScreenWrapperWithBranchLogo = ({ children, className }: { children: ReactNode; className?: string }) => {
  const { root, branchLogo } = useStyles();
  return (
    <div className={cx(root, className)}>
      <div id="branch-logo" className={branchLogo}>
        <img src={ImageService.getImageUrl(BRANCH_LOGO_FILE_LOCATION)} />
      </div>
      {children}
    </div>
  );
};

export default FullScreenWrapperWithBranchLogo;
